import { renderBoolean } from 'KnmPackage/KnmHistoriesModule/common/renderBoolean';
import { renderDate } from 'KnmPackage/KnmHistoriesModule/common/renderDate';

export const getViolationsHistoryFields = (name: string) => ({
  [`/${name}/status`]: {
    name: 'Статус нарушения',
    active: true,
  },
  [`/${name}/description`]: {
    name: 'Описание нарушения',
    active: true,
  },
  [`/${name}/notRemoval`]: {
    name: 'Нарушение не подлежит устранению',
    active: true,
    renderFunc: renderBoolean,
  },
  [`/${name}/correctedInEvent`]: {
    name: 'Нарушение устранено в ходе мероприятия',
    active: true,
    renderFunc: renderBoolean,
  },
  [`/${name}/corrected`]: {
    name: 'Нарушение устранено',
    active: true,
    renderFunc: renderBoolean,
  },
  [`/${name}/appealed`]: {
    name: 'Нарушение обжаловано',
    active: true,
    renderFunc: renderBoolean,
  },
  [`/${name}/explanation`]: {
    name: 'Пояснение к нарушению',
    active: true,
  },
  [`/${name}/dateResolvedByAgreement`]: {
    name: 'Дата устранения по соглашению',
    active: true,
    renderFunc: renderDate,
  },

  [`/${name}/actualMethod/title`]: {
    name: 'Фактический способ устранения нарушения',
    active: true,
  },
  [`/${name}/actualEliminationDate`]: {
    name: 'Фактическая дата устранения нарушения',
    active: true,
    renderFunc: renderDate,
  },

  [`/${name}/remediationPlan/plannedEliminationDates/{id}/value`]: {
    name: 'Плановая дата устранения нарушения',
    active: true,
    renderFunc: renderDate,
  },
  [`/${name}/remediationPlan/plannedMethod/{id}/title`]: {
    name: 'Планируемый способ устранения нарушения',
    active: true,
  },
  [`/${name}/remediationPlan/descriptions/{id}/value`]: {
    name: 'Пояснение инспектора к устранению нарушения',
    active: true,
  },

  [`/${name}/eliminationViolations/{id}/materialType/{id}/title`]: {
    name: 'Сведения о факте устранения нарушения - Тип материала',
    active: true,
  },
  [`/${name}/eliminationViolations/{id}/attachments/{id}/attachment/fileName`]: {
    name: 'Сведения о факте устранения нарушения - Файлы',
    active: true,
  },
  [`/${name}/eliminationViolations/{id}/descriptionGrade`]: {
    name: 'Сведения о факте устранения нарушения - Пояснение к оценке исправления',
    active: true,
  },
  [`/${name}/eliminationViolations/{id}/grade`]: {
    name: 'Сведения о факте устранения нарушения - Оценка исправления',
    active: true,
  },
  [`/${name}/eliminationViolations/{id}/actualMethod/title`]: {
    name: 'Сведения о факте устранения нарушения - Фактический способ устранения',
    active: true,
  },
  [`/${name}/eliminationViolations/{id}/descriptionMaterial`]: {
    name: 'Сведения о факте устранения нарушения - Пояснение к типу материала',
    active: true,
  },
});
